import { round } from 'lodash';

export const roundDecimals = (value) => (!value ? '' : round(value, 2).toLocaleString(undefined, {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
}));
export const isValidNumber = (value) => (Number(value) > 0 ? value : '-');
export const parseUndefined = (value) => (value === 'undefined' ? undefined : value);
export const toRem = (value, percentage) => value * percentage + 10;
